import * as React from 'react'
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { styled } from '@mui/material/styles'

interface IProps {
  activeStep: number
  steps: string[]
}

const CustomStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean }
}>(({ ownerState }) => ({
  backgroundColor: ownerState.active ? '#fff' : ownerState.completed ? '#2D749C' : '#ccc',
  border: ownerState.active ? '2px solid #2D749C' : 'none',
  zIndex: 1,
  color: ownerState.active ? '#2D749C' : '#fff',
  width: 24,
  height: 24,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '0.75rem',
  fontWeight: 'bold',
  boxSizing: 'border-box',
}))

const CustomStepper = styled(Stepper)(() => ({
  '& .MuiStepConnector-line': {
    borderColor: '#2D749C',
    borderTopWidth: 1,
  },
  '& .MuiStepLabel-root .MuiStepLabel-label': {
    fontSize: '0.875rem',
    color: '#999',
    '&.Mui-active': {
      color: '#2D749C',
      fontWeight: 'bold',
    },
    '&.Mui-completed': {
      color: '#2D749C',
      fontWeight: 'bold',
    },
  },
}))

function CustomStepIcon(props: any) {
  const { active, completed, icon } = props

  return <CustomStepIconRoot ownerState={{ completed, active }}>{icon}</CustomStepIconRoot>
}

function Steps(props: IProps) {
  const { activeStep, steps = [] } = props

  return (
    <Box sx={{ width: '100%' }}>
      <CustomStepper activeStep={activeStep || 0} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </CustomStepper>
    </Box>
  )
}

export default Steps
